<script lang="ts" context="module">
  export const ButtonSize = {
    Base: "base",
    Large: "large",
    Small: "small",
    Tiny: "tiny",
  }
</script>

<script lang="ts">
  import link from "@actions/use-link"

  export let href: string | null = null
  export let type = "primary"
  export let size = "base"
  export let disabled = false
  export let external = false
  export let hard = false
  export let submit = false
  export let tabindex: number | undefined = undefined

  export let excludeBaseStyle = false

  let className = ""
  export { className as class }

  const Sizes = {
    base: "button--base [ px-5 py-2 ]",
    tiny: "button--tiny [ px-1 py-0.5 text-xs ]",
    small: "button--small [ px-3 py-1 text-sm ]",
    large: "button--large [ px-8 py-3 font-semibold text-lg tracking-tight w-full flex ]",
    none: "",
  }

  const Types = {
    primary: "button--primary [ bg-primary border-primary text-white ]",
    neutral: "button--neutral [ bg-neutral-200 border-neutral-200 ]",
    destructive: "button--destructive [ bg-red-200 text-red-700 border-red-200 ]",
    clear: "button--clear [ bg-transparent border-transparent ]",
    outline: "button--clear [ bg-transparent ]",
    none: "",
  }
</script>

{#if href}
  <a
    {href}
    {tabindex}
    on:click
    use:link={!external || hard}
    target={external ? "_blank" : "_self"}
    rel={external ? 'rel="noopener noreferrer"' : ""}
    class="{className} {excludeBaseStyle ? '' : 'border inline-flex items-center justify-center'} {Sizes[size]} {Types[
      type
    ]}"
  >
    <slot />
  </a>
{:else}
  <button
    type={submit ? "submit" : "button"}
    {disabled}
    {tabindex}
    on:click
    aria-disabled={disabled ? "true" : "false"}
    class="{className} [ border inline-flex items-center justify-center ] {Sizes[size]} {Types[type]}"
    class:opacity-50={disabled}
    class:pointer-events-none={disabled}
  >
    <slot />
  </button>
{/if}
